import {
    Exercise,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData34Completed: ExerciseData = {
    ExerciseView: Module3Exercise4Completed,
    dataKeys: [],
    questions: [],
};

function Module3Exercise4Completed({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="" className="clouds text-center">
            <Spacer />
            <LabelDisplay2 className="mb-10">Godt gået!</LabelDisplay2>
            <LabelBody>
                Du har nu lavet alle øvelserne i modul 3. Tag et øjeblik og
                anerkend dig selv for din indsats.
            </LabelBody>
            <LabelBody className="my-10">
                Der er ikke noget af det, du er blevet introduceret for, som er
                quick fixes. Der er redskaber, man skal bruge over tid for at
                mærke en effekt. Husk på at du er den, der ved, hvad der er
                rigtigt for dig.
            </LabelBody>
            <LabelBody>
                Eksperimenter med hvad der kunne være gode greb for dig i din
                hverdag. Næste skridt er at det 4. og sidste modul blive åbnet.
            </LabelBody>
            <Spacer />
            <SecondaryButton
                className="mt-30"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Tilbage til modulet
            </SecondaryButton>
        </Exercise>
    );
}
